var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_ClaimReason_form_editTitle")
        : _vm.$t("label_essweb_ClaimReason_form_viewTitle"),
      widthClass: "max-1000",
      backgroundClass: "white",
      editBtn: !_vm.iSEdited,
      initData: _vm.ClaimReasonData,
      checkData: [
        "claim_reason_name",
        "sequence",
        "claim_reason_description",
        "claim_reason_code",
        "claim_type_uuid",
        "remarks",
      ],
      delBtn: "",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_ClaimReason_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "100",
                            readonly: !_vm.iSEdited,
                            bindData: _vm.ClaimReasonData.claim_reason_name,
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_claimReasonNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.ClaimReasonData.claim_reason_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_ClaimReason_form_claimTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            items: _vm.ClaimType,
                            "item-text": "claim_type_name",
                            "item-value": "uuid",
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimReason_form_claimTypeLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.ClaimReasonData.claim_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimReasonData,
                                "claim_type_uuid",
                                $$v
                              )
                            },
                            expression: "ClaimReasonData.claim_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "100",
                            rules: _vm.$GetRules(
                              ["_Require_Rules", "_Length_Rules"],
                              [null, 100]
                            ),
                            readonly: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_codeLabel"
                            ),
                          },
                          model: {
                            value: _vm.ClaimReasonData.claim_reason_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ClaimReasonData,
                                "claim_reason_code",
                                $$v
                              )
                            },
                            expression: "ClaimReasonData.claim_reason_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { md: _vm.iSEdited ? 3 : 6 } },
                      [
                        _c("numberInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "50",
                            readonly: !_vm.iSEdited,
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 50]
                            ),
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_sequenceLabel"
                            ),
                          },
                          model: {
                            value: _vm.ClaimReasonData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.ClaimReasonData, "sequence", $$v)
                            },
                            expression: "ClaimReasonData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            maxlength: "500",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData:
                              _vm.ClaimReasonData.claim_reason_description,
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_descriptioneLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.ClaimReasonData.claim_reason_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_ClaimReason_form_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            counter: "500",
                            dense: "",
                            "single-line": "",
                            name: "input-7-4",
                          },
                          model: {
                            value: _vm.ClaimReasonData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.ClaimReasonData, "remarks", $$v)
                            },
                            expression: "ClaimReasonData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }